import { useSyncExternalStore } from 'react'

/**
 * Hoe vaak de vooruitblik uit zichzelf kijkt of iemand anders iets veranderd
 * heeft. Vijf seconden: het scherm is FINANCE-only, dus er zitten er hooguit een
 * handvol tegelijk in, en het is één GET per persoon. Een collega die een cel
 * verzet hoort te verschijnen voor je je afvraagt of je het scherm moet
 * verversen.
 */
export const PLANNING_REFRESH_MS = 5_000

/**
 * Zolang iemand aan het invullen of slepen is staat die verversing stil.
 *
 * Een urencel bewaart je ruwe invoer in een eigen draft tot je bevestigt. Nieuwe
 * servergegevens vervangen wel de onderliggende waarde maar niet je draft, en
 * dan schrijf je bij bevestigen een getal weg tegen een stand die je nooit
 * gezien hebt. Wachten tot de hand van de gebruiker weg is, is eerlijker dan
 * halverwege iets onder hem veranderen: een paar seconden later komt de
 * wijziging van de collega alsnog binnen.
 *
 * Een teller en niet een vlag, want er kunnen er meerdere tegelijk openstaan (een
 * cel in bewerking terwijl een eerdere schrijfactie nog onderweg is).
 */
let openEdits = 0
const listeners = new Set<() => void>()

/** Pauzeert de verversing tot de teruggegeven functie wordt aangeroepen. */
export function beginPlanningEdit(): () => void {
  openEdits += 1
  if (1 === openEdits) notify()

  let released = false

  return () => {
    if (released) return
    released = true
    openEdits -= 1
    if (0 === openEdits) notify()
  }
}

export function isPlanningEditing(): boolean {
  return openEdits > 0
}

export function subscribePlanningEditing(listener: () => void): () => void {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}

export function usePlanningEditing(): boolean {
  return useSyncExternalStore(subscribePlanningEditing, isPlanningEditing, () => false)
}

function notify(): void {
  for (const listener of listeners) listener()
}
